/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { createListButtonStyles } from "@monsma/Overrides/Widgets/MyLists/MyListsCreateListButton";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

createListButtonStyles.createListButton = {
    variant: "primary",
};

createListButtonStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;

        ${screen("lt", "sm")} {
            position: absolute;
            top: 0;
            right: 0;
            padding: 5px 15px;
        }
    `,
};
